export enum MessagesActionTypes {
  INITIALIZE_CLIENT_START = 'INITIALIZE_CLIENT_START',
  INITIALIZE_CLIENT_DONE = 'INITIALIZE_CLIENT_DONE',
  INITIALIZE_CLIENT_FAILED = 'INITIALIZE_CLIENT_FAILED',
  SET_CREATED_CHANNEL = 'SET_CREATED_CHANNEL',
  RESET_CLIENT = 'RESET_CLIENT',
  SET_UNREAD_MESSAGES_COUNT = 'SET_UNREAD_MESSAGES_COUNT',
  SET_NO_CHANNEL_LOADED = 'SET_NO_CHANNEL_LOADED',
  SET_LOADING_CHANNEL_ERROR = 'SET_LOADING_CHANNEL_ERROR',
  ADD_DELETED_CHANNEL = 'ADD_DELETED_CHANNEL',
  SET_TOTAL_UNREAD_MESSAGES_BY_COMPANY = 'SET_TOTAL_UNREAD_MESSAGES_BY_COMPANY',
  INCREMENT_TOTAL_UNREAD_MESSAGES_BY_COMPANY = 'INCREMENT_TOTAL_UNREAD_MESSAGES_BY_COMPANY',
  SET_CHANNEL_ID_TO_COMPANY_ID = 'SET_CHANNEL_ID_TO_COMPANY_ID',
}

export type ChannelMembershipType = 'individual' | 'company' | 'group';

export interface MessageChannelEntity {
  fields: {
    name: string;
    members: string[];
    getstreamMembers: string[];
    companyID: string;
    membersType: ChannelMembershipType;
  };
}

export interface MessagesState {
  clientInitialized: boolean;
  clientInitializing: boolean;
  createdChannelId?: string; // used to set the active channel after creation using the channel id
  currentUserId?: string;
  totalUnreadMessages?: number;
  totalUnreadMessagesByCompany: Record<string, number> | null;
  channelIdToCompanyId: Record<string, string> | null;
  noChannelLoaded: boolean;
  loadingError: string;
  deletedChannels?: string[];
}

interface InitializeClientStartAction {
  type: typeof MessagesActionTypes.INITIALIZE_CLIENT_START;
}

interface InitializeClientStartDone {
  type: typeof MessagesActionTypes.INITIALIZE_CLIENT_DONE;
  currentUserId?: string;
}

interface InitializeClientFailedAction {
  type: typeof MessagesActionTypes.INITIALIZE_CLIENT_FAILED;
}

interface SetCreatedChannelAction {
  type: typeof MessagesActionTypes.SET_CREATED_CHANNEL;
  createdChannelId: string;
}

interface SetNoChannelLoadedAction {
  type: typeof MessagesActionTypes.SET_NO_CHANNEL_LOADED;
  payload: boolean;
}

interface SetChannelLoadingErrorAction {
  type: typeof MessagesActionTypes.SET_LOADING_CHANNEL_ERROR;
  payload: string;
}

interface ResetClientAction {
  type: typeof MessagesActionTypes.RESET_CLIENT;
}

interface SetUnreadMessagesAction {
  type: typeof MessagesActionTypes.SET_UNREAD_MESSAGES_COUNT;
  payload: number;
}

interface AddDeletedChannelAction {
  type: typeof MessagesActionTypes.ADD_DELETED_CHANNEL;
  payload: string;
}

interface SetTotalUnreadMessagesByCompanyAction {
  type: typeof MessagesActionTypes.SET_TOTAL_UNREAD_MESSAGES_BY_COMPANY;
  payload: {
    companyId: string;
    totalUnreadMessagesCount: number;
  };
}

interface IncrementTotalUnreadMessagesByCompanyAction {
  type: typeof MessagesActionTypes.INCREMENT_TOTAL_UNREAD_MESSAGES_BY_COMPANY;
  payload: {
    companyId: string;
    incrementCount: number;
  };
}

interface SetChannelIdToCompanyIdAction {
  type: typeof MessagesActionTypes.SET_CHANNEL_ID_TO_COMPANY_ID;
  payload: {
    channelId: string;
    companyId: string;
  };
}
export type MessagesActions =
  | InitializeClientStartAction
  | InitializeClientStartDone
  | InitializeClientFailedAction
  | SetCreatedChannelAction
  | ResetClientAction
  | SetUnreadMessagesAction
  | SetNoChannelLoadedAction
  | SetChannelLoadingErrorAction
  | SetTotalUnreadMessagesByCompanyAction
  | IncrementTotalUnreadMessagesByCompanyAction
  | SetChannelIdToCompanyIdAction
  | AddDeletedChannelAction;
